<template>
  <f-n-j-select  :reserve-keyword="true" ref="select" @remove-tag="handleRemove" collapseTags :value=" this.checkList" multiple
                :clearable="clearable" @clear="clearHandle" filterable :filter-method="handleSearch"
                @visible-change="visibleChange">



    <div class="tree-select">

      <el-tree

        :check-strictly="true"
        id="tree-option"
        ref="selectTree"
        show-checkbox
        check-on-click-node
        :expand-on-click-node="false"
        :data="options"
        :props="props"
        :node-key="props.value"
        default-expand-all
        :filter-node-method="filterNode"
        @check="handleClick"
        @node-click="handleNodeClick">
      </el-tree>


    </div>


    <!--<el-option :value="valueTitle" :label="valueTitle" class="options">-->

    <!---->

    <!--</el-option>-->
  </f-n-j-select>
</template>

<style>
  .tree-select{

  }
</style>

<script>
    import FNJSelect from "@/components/TreeSelect/FNJSelect";

    export default {
        name: "el-tree-select",
        components: {FNJSelect},
        props: {
            // 配置项
            props: {
                type: Object,
                default: {
                    value: 'id',             // ID字段名
                    label: 'title',         // 显示名称
                    children: 'children'    // 子级字段名
                }
            },

            // 选项列表数据(树形结构的对象数组)
            options: {type: Array, default: []},

            // 初始值
            value: {default: null},
            filterMethod: {type: Function, default: null},

            // 可清空选项
            clearable: {type: Boolean, default: true},

            // 自动收起
            accordion: {type: Boolean, default: false}
        },
        data() {
            return {
                valueId: null,
                valueTitle: '',
                defaultExpandedKey: [],
                checkList: [],
                oriCheckListData: []
            }
        },

        mounted() {
            this.valueId = this.value,    // 初始值
                this.initHandle()
        },
        methods: {
            setCheckList(list){
                this.checkList=list

            },
            handleRemove(tag) {
                this.oriCheckListData = this.oriCheckListData.filter(item => {
                    return item[this.props.label] !== tag;
                });
                this.checkList = this.oriCheckListData.map(item => {
                    return item[this.props.label];
                })
                let ids = this.oriCheckListData.map(item => {
                    return item[this.props.value]
                });

                this.$refs.selectTree.setCheckedKeys(ids);
                this.$emit("change", ids)
            },
            handleClick() {
                let checkNode = this.$refs.selectTree.getCheckedNodes();
                let addList = checkNode.filter(item => {
                    return !this.oriCheckListData.includes(item)
                });
                let checkList = [...this.oriCheckListData, ...addList];
                this.oriCheckListData = checkList.filter(item => {
                    return checkNode.find(item2 => {
                        return item2[this.props.label] == item[this.props.label]
                    })
                })
                this.checkList = this.oriCheckListData.map(item => {
                    return item[this.props.label];
                })
                let ids = this.oriCheckListData.map(item => {

                    return item[this.props.value]
                });
                this.$emit("change", ids)


            },
            filterNode(value, data,node) {
                if (!value) return true;
            //    return data.operatorName.indexOf(value) !== -1  ||( node.parent && node.parent.data &&node.parent.data.operatorName.indexOf(value) !== -1);
                return this.chooseNode(value, data,node)
            },
            // 过滤父节点，子节点：如果输入的参数是父节点且能匹配，则返回该节点以及其下的所有子节点
            chooseNode(value,data,node){
                if(data.operatorName.indexOf(value) !== -1){
                    return true
                }
                const level = node.level;
                // 如果只有一级，就不用效验了
                if(level===1){
                    return false;
                }
                // console.log(node)
                // 先取当前父节点
                let parentData = node.parent
                // 遍历当前节点的父节点
                let index = 0;
                while(index < level-1){
                    // 如果匹配到直接返回
                    if(parentData.data.operatorName.indexOf(value) !== -1){
                        return true  //判断上级是否存在value，存在显示子节点，不存在，不显示子节点
                    }
                    // 否则再往上一层做匹配
                    parentData = parentData.parent;
                    index++
                }
                // 没匹配到返回false
                return false;

            },
            visibleChange() {
                this.$refs.selectTree.filter("");
                // this.$emit("filter-method","")
            },
            handleSearch(data) {
                console.log(data)
                this.$refs.selectTree.filter(data);
                // this.$emit("filter-method",data)


            },

            // 初始化值
            initHandle() {
                this.$nextTick(() => {

                    this.$refs.selectTree.setCheckedKeys(this.valueId);
                    if (this.valueId) {
                        this.defaultExpandedKey = this.valueId ;


                        // 设置默认展开
                    } else {
                        this.valueTitle = "";
                    }


                })
            },

            // 切换选项
            handleNodeClick(node) {
                this.valueTitle = node[this.props.label]
                this.valueId = node[this.props.value]
                this.$emit('getValue', this.valueId)
                this.defaultExpandedKey = []
            },
            // 清除选中
            clearHandle() {
                this.valueTitle = ''
                this.valueId = null
                this.defaultExpandedKey = [];
                this.checkList = [];
                this.clearSelected();
                this.$refs.selectTree.setCheckedKeys([]);
                this.$emit('getValue', []);
                this.$emit("change", [])
            },
            // 清空选中样式
            clearSelected() {
                let allNode = document.querySelectorAll('#tree-option .el-tree-node')
                allNode.forEach((element) => element.classList.remove('is-current'))
            }
        },
        watch: {
            options:{
                immediate: true,
                handler(value) {




                }
            },
            value: {
                immediate: true,
                handler(value) {

                    if(value){
                        value=    value.filter(item=>{
                            return   item
                        })
                    }

                    if (value && value.length!=0) {
                        this.valueId = value;
                    } else {
                        this.valueId = [];
                        this.setCheckList([]);
                    }

                    this.initHandle()



                }


            }
        },
    }
</script>

<style lang="scss">
  .tree-select {
    position: relative;
    z-index: 10;
    .el-tree-node__content {
      font-size: 14px;
      padding: 0 20px;
      position: relative;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #606266;
      height: 34px;
      line-height: 34px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      cursor: pointer;
    }
  }

</style>
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/TreeSelect/index2.vue